import {Pipe, PipeTransform} from '@angular/core';
import {Pushpin} from '../classes/pushpin.class';
import {StatusService} from '../services/status/status.service';

@Pipe({
    name: 'polylineColor'
})
export class PolylineColorPipe implements PipeTransform {
    constructor(private statusService: StatusService) {
    }

    transform(pushpin: Pushpin): string {
        let color = 'FF0000';
        if (pushpin.pushpin_parts && this.statusService) {
            const heaviestStatuses = this.statusService.getHeaviestStatuses(pushpin.pushpin_parts);
            if (heaviestStatuses.length !== 0) {
                color = heaviestStatuses[0].color;
            }
        }
        return color;
    }
}
